/* eslint no-param-reassign: 0 */
import { distanceMap } from '../../utils/distance';
import { getYearFromUtc } from '../../utils/date';
import { fromObjToArray } from '../../utils/object';

// adding year to month to make it parsible for "new Date()"
const year = getYearFromUtc();
const addDateStr = data =>
    data.map(row => ({ ...row, dateStr: `${row.monthName} ${year}` }));

// keys that are calculated as summ of values
const summKeys = [
    'place1stNumber', 'place2ndNumber', 'place3rdNumber',
    'startsNumber', 'netWinPrize', 'netTotalPrize',
];

// keys that are calculated as maximum of values
const maxKeys = ['distanceYard', 'bestRpTopspeed', 'bestRpPostmark'];

const createEmptyRow = () => {
    const row = {};
    [...summKeys, ...maxKeys].forEach((key) => {
        row[key] = 0;
    });
    return row;
};

// aggregating data by groups
const aggrData = (data, groupKey, raceType) => {
    const isDistance = groupKey === 'distanceYard';

    const groupedData = data.reduce((acc, item) => {
        const group = isDistance ?
            distanceMap(item.distanceYard, raceType) : item[groupKey];

        if (!acc[group]) {
            acc[group] = createEmptyRow();
        }

        summKeys.forEach((key) => {
            acc[group][key] += item[key];
        });

        maxKeys.forEach((key) => {
            acc[group][key] = Math.max(item[key], acc[group][key]);
        });

        return acc;
    }, {});

    const newGroupKey = isDistance ? 'distance' : 'going';

    return fromObjToArray(groupedData, newGroupKey);
};

const transformData = ({ month, going, distance, ...rest }, raceType) => ({
    month: addDateStr(month),
    going: aggrData(going, 'goingTypeDesc'),
    distance: aggrData(distance, 'distanceYard', raceType),
    ...rest,
});

export default transformData;



// WEBPACK FOOTER //
// ./src/js/horse/stats/transformData.js